module.exports = __webpack_public_path__ + "img/111.51fdad62.jpg";